module.exports = __webpack_public_path__ + "img/webinar-expert.5e1b1892.png";